/* Read-only section polling picks up revised dates, membership, prices and stock. */
(() => {
  const cleanups = new WeakMap();
  const init = root => {
    if (cleanups.has(root)) return;
    const wrapper = root.closest('[id^="shopify-section-"]');
    if (!wrapper) return;
    const lifetime = new AbortController();
    let pending = false;
    const revision = node => node.dataset.storefrontRevision || node.querySelector('[data-storefront-revision]')?.dataset.storefrontRevision;
    const dispose = () => { lifetime.abort(); clearInterval(timer); };
    const refresh = async () => {
      if (!root.isConnected) { dispose(); return; }
      if (pending || document.hidden || root.dataset.purchaseBusy || root.contains(document.activeElement)) return;
      pending = true;
      try {
        const requestedURL = location.href;
        const url = new URL(requestedURL);
        url.searchParams.set('section_id', wrapper.id.replace(/^shopify-section-/, ''));
        url.searchParams.set('_', String(Date.now()));
        const response = await fetch(url, { signal: lifetime.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Section unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const freshWrapper = page.getElementById(wrapper.id);
        const selector = root.hasAttribute('data-product-root') ? '[data-product-root]' : '[data-collection-root]';
        const fresh = freshWrapper?.querySelector(selector);
        if (!fresh || !root.isConnected || lifetime.signal.aborted || location.href !== requestedURL || root.dataset.purchaseBusy || root.contains(document.activeElement)) return;
        window.CheapUndiesDeal?.sync(fresh.dataset.serverNow);
        if (!revision(fresh) || revision(fresh) === revision(root)) return;
        const choices = [...root.querySelectorAll('[data-card-option-value][aria-pressed="true"]')].map(button => ({
          handle: button.closest('[data-product-handle]').dataset.productHandle,
          group: button.closest('[data-card-option-index]').dataset.cardOptionIndex,
          value: button.dataset.cardOptionValue
        }));
        const details = [...root.querySelectorAll('details')].map((detail, index) => ({ index, open: detail.open }));
        wrapper.dispatchEvent(new Event('shopify:section:unload', { bubbles: true }));
        dispose();
        wrapper.replaceWith(freshWrapper);
        freshWrapper.dispatchEvent(new Event('shopify:section:load', { bubbles: true }));
        choices.forEach(choice => {
          const card = [...fresh.querySelectorAll('.product-card')].find(card => card.dataset.productHandle === choice.handle);
          const group = card?.querySelector(`[data-card-option-index="${choice.group}"]`);
          const button = [...(group?.querySelectorAll('[data-card-option-value]') || [])].find(button => button.dataset.cardOptionValue === choice.value);
          if (button && !button.disabled) button.click();
        });
        details.forEach(({index, open}) => { const detail = fresh.querySelectorAll('details')[index]; if (detail) detail.open = open; });
      } catch (_) {
        // Keep the rendered section; submission still confirms current Shopify data.
      } finally { pending = false; }
    };
    const timer = setInterval(refresh, 30000);
    cleanups.set(root, dispose);
    document.addEventListener('visibilitychange', refresh, { signal: lifetime.signal });
  };
  const initWithin = scope => scope.querySelectorAll('[data-product-root], [data-collection-root]').forEach(init);
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-root], [data-collection-root]').forEach(root => cleanups.get(root)?.()));
})();
